/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DeleteBeneficiaryMutation from '../graphql/mutations/DeleteBeneficiaryMutation.js';

export const useDeleteBeneficiaryMutation = () => {
  return useCommitMutation(DeleteBeneficiaryMutation, {
    dataProp: 'deleteBeneficiary_M_simulation_customer_grantees'
  });
};

export default useDeleteBeneficiaryMutation;
